import {isEmpty} from "@pg-mono/nodash";

import {IOSMPoisRoutesGrouped} from "../actions/fetch_osm_pois_routes_grouped";

export const isRailTransportAvailable = (regionRoutes: (IOSMPoisRoutesGrouped | null)[] | null) => {
    if (!regionRoutes) {
        return false;
    }

    return Boolean(
        regionRoutes.find((regionRouteGroup) => {
            if (!regionRouteGroup) {
                return false;
            }

            const {subway, tram, train} = regionRouteGroup;
            return !isEmpty(subway) || !isEmpty(tram) || !isEmpty(train);
        })
    );
};
import {isEmpty} from "@pg-mono/nodash";

import {IOSMPoisRoutesGrouped} from "../actions/fetch_osm_pois_routes_grouped";

export const isRailTransportAvailable = (regionRoutes: (IOSMPoisRoutesGrouped | null)[] | null) => {
    if (!regionRoutes) {
        return false;
    }

    return Boolean(
        regionRoutes.find((regionRouteGroup) => {
            if (!regionRouteGroup) {
                return false;
            }

            const {subway, tram, train} = regionRouteGroup;
            return !isEmpty(subway) || !isEmpty(tram) || !isEmpty(train);
        })
    );
};
